import "./index.scss";
import LogoS from "../../assets/images/logo-s.png";

import LogoSubtitle from "../../assets/images/sayak_logo_white.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub, faTwitter, faMedium } from "@fortawesome/free-brands-svg-icons";
import { faHome, faUser, faEnvelope, faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";
import { Link, NavLink } from "react-router-dom";

const Sidebar = () => {
	return (
		<>
			<div className="nav-bar">
				<Link className="logo" to="/">
					<img src={LogoS} alt="Logo" />
					<img className="sub-logo" src={LogoSubtitle} alt="slobodan" />
				</Link>
				<nav>
					<NavLink exact="true" activeclassname="active" to="/">
						<FontAwesomeIcon icon={faHome} color="#1CD2B2" />
					</NavLink>
					<NavLink activeclassname="active" className="about-link" to="/about">
						<FontAwesomeIcon icon={faUser} color="#1CD2B2" />
					</NavLink>

					<NavLink activeclassname="active" className="skills-link" to="/skills">
						<FontAwesomeIcon icon={faScrewdriverWrench} color="#1CD2B2" />
					</NavLink>

					<NavLink activeclassname="active" className="contact-link" to="/contact">
						<FontAwesomeIcon icon={faEnvelope} color="#1CD2B2" />
					</NavLink>
				</nav>
				<ul>
					<li>
						<a href="https://github.com/sayak-dutta" target="_blank" rel="noreferrer">
							<FontAwesomeIcon icon={faGithub} color="#b9b9b9" />
						</a>
					</li>
					<li>
						<a
							href="https://www.linkedin.com/in/sayakduttaa/"
							target="_blank"
							rel="noreferrer"
						>
							<FontAwesomeIcon icon={faLinkedin} color="#b9b9b9" />
						</a>
					</li>
					<li>
						<a href="https://twitter.com/sayakduttaa" target="_blank" rel="noreferrer">
							<FontAwesomeIcon icon={faTwitter} color="#b9b9b9" />
						</a>
					</li>

					<li>
						<a href="https://medium.com/@sayakduttaa" target="_blank" rel="noreferrer">
							<FontAwesomeIcon icon={faMedium} color="#b9b9b9" />
						</a>
					</li>
				</ul>
			</div>
		</>
	);
};

export default Sidebar;
